import { reactive } from 'vue'

export const navigationRecovery = reactive({ open: false, target: '' })
const KEY = 'corecry:navigation-recovery'
const CHUNK_ERROR = /failed to fetch dynamically imported module|importing a module script failed|failed to load module script|unable to preload css|error loading dynamically imported module/i

function hasPotentialUnsavedChanges(document) {
    return [...document.querySelectorAll('input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), select:not([disabled])')]
        .some(element => element.type === 'checkbox' || element.type === 'radio'
            ? element.checked !== element.defaultChecked
            : element.tagName === 'SELECT'
                ? [...element.options].some(option => option.selected !== option.defaultSelected)
                : element.value !== element.defaultValue)
}

export function recoverFailedNavigation(error, to, from, environment = globalThis) {
    if (!CHUNK_ERROR.test(String(error?.message || error))) return false
    const target = to?.fullPath || '/'
    const editor = /^\/(create-bot|edit-bot)(\/|$)/.test(from?.path || '')
    let alreadyTried = true
    try { alreadyTried = environment.sessionStorage.getItem(KEY) === target } catch { /* do not risk a reload loop */ }
    if (!editor && !hasPotentialUnsavedChanges(environment.document) && !alreadyTried) {
        try {
            environment.sessionStorage.setItem(KEY, target)
            environment.location.assign(target)
            return true
        } catch { /* preserve the current document */ }
    }
    Object.assign(navigationRecovery, { open: true, target })
    return true
}

export function installNavigationRecovery(router) {
    router.onError((error, to, from) => { recoverFailedNavigation(error, to, from) })
    router.afterEach((to, from, failure) => {
        if (!failure) {
            try { if (sessionStorage.getItem(KEY) === to.fullPath) sessionStorage.removeItem(KEY) } catch { /* storage may be disabled */ }
        }
    })
}
